import {
  LOGIN_REQUEST,
  LOGIN_REQUEST_FAILED,
  LOGIN_REQUEST_SUCCESS,
  LOG_OUT_USER,
  SET_USER_DETAILS,
  ADD_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  EDIT_USER_SUCCESS,
  GET_USER_ERROR,
  GET_USER_SUCCESS,
  RESET_USER_DETAILS,
  GET_USERROLES_SUCCESS,
  GET_USERROLES_FAILED,
  GET_ALL_USER_SUCCESS,
  USER_ACTION_SUCCESS,
  CREATE_SINGLE_USER_FILE_SUCCESS,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWWORD_FAILED,
  RESET_FORGET_PASSWORD,
  VALIDATE_PASSWORD_SUCCESS,
  VALIDATE_PASSWORD_FAILED,
  RESET_VALIDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  RESET_UPDATE_PASSWORD_SUCCESS,
  GET_ALL_USER_CSV_SUCCESS,
  GET_LOGIN_HOSTORY_PAST_30_DAYS,
  RESET_LOGIN_HOSTORY_PAST_30_DAYS,
  GET_LOGIN_ROLE_COUNT,
  RESET_LOGIN_ROLE_COUNT,
  GET_LOGIN_COUNT_HISTORY_SUCCESS,
  GET_USER_ID_SUCCESS,
  RESET_USER_BY_ID_SUCCESS,
  SEND_EMAIL_TO_USER_ERROR,
  SEND_EMAIL_TO_USER_SUCCESS,
  GET_PASSED_STUDENTS_CSV_SUCCESS,
  EDIT_USER_IMAGE_SUCCESS,
} from "../constants";
import { cloneDeep, remove, findIndex } from "lodash";

export const initialState = {
  userDetails: undefined,
  displayUserDetails: undefined,
  userActionDetails: undefined,
  userProfile: undefined,
  displayUserDetailsError: "",
  userRoles: undefined,
  userList: [],
  forgetPasswordLink: undefined,
  validatePasswordResponse: undefined,
  updatePasswordDetails: undefined,
  userCsvList: undefined,
  studentCsvList: undefined,
  userLoginHistory: undefined,
  userLoginCount: undefined,
  userLoginCountHomePage: undefined,
  // userLogoutDetails: [],
  singleUser: undefined,
  emailSended: undefined,
};
export const UserReducer = (state = initialState, action) => {
  //switch between action.type

  switch (action.type) {
    //if action is of type SIGN_IN or SIGN_UP return the state by setting token to the payload
    case LOGIN_REQUEST:
      return {
        ...state,
      };
    case LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        token: action.payload.access_token,
        userDetails: action.payload.user,
      };
    case LOGIN_REQUEST_FAILED:
      return {
        ...state,
        //token: action.token,
        userDetails: undefined,
      };
    case SET_USER_DETAILS:
      
      return {
        ...state,
        //token: action.token,
        userDetails: action.payload,
      };
    case LOG_OUT_USER:
      return {
        ...state,
        //token: action.token,
        userDetails: undefined,
        token: undefined,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        displayUserDetails: action.payload,
      };
    case GET_USER_ERROR:
      return {
        ...state,
        displayUserDetails: [],
        displayUserDetailsError: action.payload,
      };
    case GET_USER_ID_SUCCESS: {
      return {
        ...state,
        singleUser: action.payload,
      };
    }
    case RESET_USER_BY_ID_SUCCESS: {
      return {
        ...state,
        singleUser: undefined,
      };
    }
    case ADD_USER_SUCCESS:
      const tempUserAddDetails = cloneDeep(state.displayUserDetails);
      tempUserAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        displayUserDetails: tempUserAddDetails,
        displayUserDetailsError: "",
      };
    case EDIT_USER_IMAGE_SUCCESS: {
      return {
        ...state,
        singleUser: action.payload,
      };
    }
    case EDIT_USER_SUCCESS:
      const tempUserUpdateDetails = cloneDeep(state.displayUserDetails);
      const index = findIndex(tempUserUpdateDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempUserUpdateDetails.data.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        displayUserDetails: tempUserUpdateDetails,
      };

    case DELETE_USER_SUCCESS:
      const tempUserDetails = cloneDeep(state.displayUserDetails);
      remove(tempUserDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        displayUserDetails: tempUserDetails,
      };

    case RESET_USER_DETAILS:
      return {
        ...state,
        displayUserDetails: undefined,
      };

    case GET_USERROLES_SUCCESS:
      return {
        ...state,
        userRoles: action.payload,
      };
    case GET_USERROLES_FAILED:
      return {
        ...state,
        userRoles: undefined,
      };

    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        userList: action.payload,
      };
    case USER_ACTION_SUCCESS:
      const tempUserActionDetails = cloneDeep(state.userActionDetails);
      tempUserActionDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        userActionDetails: tempUserActionDetails,
        displayUserDetailsError: "",
      };
    // case CREATE_SINGLE_USER_FILE_SUCCESS: {
    //   const tempoResFileDetail = cloneDeep(state.userProfile);
    //
    //

    //   tempoResFileDetail.data.push(action.payload);
    //   return {
    //     ...state,
    //     userProfile: tempoResFileDetail,
    //   };
    // }
    case CREATE_SINGLE_USER_FILE_SUCCESS: {
      return {
        ...state,
        userProfile: action.payload,
      };
    }
    case FORGET_PASSWORD_SUCCESS:
    case FORGET_PASSWWORD_FAILED: {
      return {
        ...state,
        forgetPasswordLink: action.payload,
      };
    }
    case VALIDATE_PASSWORD_SUCCESS:
    case VALIDATE_PASSWORD_FAILED: {
      return {
        ...state,
        validatePasswordResponse: action.payload,
      };
    }
    case UPDATE_PASSWORD_SUCCESS: {
      return {
        ...state,
        updatePasswordDetails: action.payload,
      };
    }
    case RESET_UPDATE_PASSWORD_SUCCESS: {
      return {
        ...state,
        updatePasswordDetails: undefined,
      };
    }
    case RESET_FORGET_PASSWORD: {
      return {
        ...state,
        forgetPasswordLink: undefined,
      };
    }
    case RESET_VALIDATE_PASSWORD: {
      return {
        ...state,
        validatePasswordResponse: undefined,
      };
    }
    case GET_ALL_USER_CSV_SUCCESS:
      return {
        ...state,
        userCsvList: action.payload,
      };
    case GET_PASSED_STUDENTS_CSV_SUCCESS:
      return {
        ...state,
        studentCsvList: action.payload,
      };
    case GET_LOGIN_HOSTORY_PAST_30_DAYS: {
      return {
        ...state,
        userLoginHistory: action.payload,
      };
    }
    case RESET_LOGIN_HOSTORY_PAST_30_DAYS: {
      return {
        ...state,
        userLoginHistory: "",
      };
    }
    case GET_LOGIN_ROLE_COUNT: {
      return {
        ...state,
        userLoginCount: action.payload,
      };
    }
    case RESET_LOGIN_ROLE_COUNT: {
      return {
        ...state,
        userLoginCount: "",
      };
    }
    case GET_LOGIN_COUNT_HISTORY_SUCCESS: {
      return {
        ...state,
        userLoginCountHomePage: action.payload,
      };
    }
    case SEND_EMAIL_TO_USER_SUCCESS: {
      return {
        ...state,
        emailSended: action.payload,
      };
    }
    case SEND_EMAIL_TO_USER_ERROR: {
      return {
        ...state,
        emailSended: action.payload,
      };
    }

    // case LOGOUT_DETAILS:
    //   return {
    //     ...state,
    //     userLogoutDetails: [
    //       ...state.userLogoutDetails,
    //       {
    //         userId: action.payload.userId,
    //         timestamp: new Date().getTime(),
    //       },
    //     ],
    //   };
    default:
      return state;
  }
};
